<template>
    <div v-if="promotion" class="product-detail-buybox-promotion">
        <div class="promotion-collapse collapse collapse-arrow rounded-none border-y border-border mb-3">
            <input type="checkbox" name="buybox-accordion" aria-label="Aktionsdetails anzeigen">
            <div class="collapse-title text-xl pt-5 pb-4 md:pb-5 px-0 min-h-0">
                <span class="text-headline font-semibold">{{ promotion.title }}</span>
            </div>

            <div class="collapse-content flex border rounded-lg !p-0">
                <div class="p-6 grid grid-cols-9 gap-4">
                    <div class="col-span-6 sm:col-span-5 md:col-span-3">
                        <LayoutImage
                            v-if="promotion.media"
                            :media="promotion.media"
                            :lazy-load="true"
                            fit="fit"
                            class="w-full h-auto"
                        />
                    </div>

                    <div v-if="promotion.description" class="col-span-9 md:col-span-6 prose prose-lg w-full max-w-full">
                        <div class="text-lg" v-html="promotion.description"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import type {HblProduct} from '@/utils/types'
import {usePromo} from '#imports'

const props = defineProps<{
    productData: HblProduct
}>()

const product = ref(props.productData)
const promotion = ref(null)

const {getPromotion} = usePromo()

onMounted(async () => {
    promotion.value = await getPromotion(product.value.id);
});

</script>
